/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 16:48:40
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-04 17:05:17
 * @FilePath: /unifyxp-v2-store-portal/src/router/CustomerDatabaseRoutes/index.tsx
 */
import CustomerDatabaseLayout from '@/src/layout/CustomerDatabaseLayout/CustomerDatabaseLayout';

import { IRoutes } from 'src/types/router';

import routes from 'src/config/routerConfig/CustomerDatabase/CustomerDatabase';
const route: IRoutes = {
  layout: CustomerDatabaseLayout,
  subRoutes: routes,
};
export default route;
